module.exports = __webpack_public_path__ + "img/resp-about.8d77b96d.svg";